export const realname = 'Rosalind Franklin';
export const usernameRequested = 'rosalind_franklin';
export const realnameOther = 'Dorothy Hodgkin';
export const usernameOtherRequested = 'dorothy_hodgkin';
export const noOp = () => {
  /**noOp */
};
